<template>
  <v-card class="search-container">
    <v-card-title class="header-title">
      🔍 Results related to 
      <span class="highlight">"{{ query }}"</span>
    </v-card-title>
    <PanelProducts
      :page="page"
      :length="totalPages"
      :products="products"
      @onPageChange="onPageChange"
    />
  </v-card>
</template>

<script>
import PanelProducts from '@/components/PanelProducts.vue'
import apisProducts from '@/apis/apisProducts'

export default {
  name: "SearchProductView",
  components: { PanelProducts },
  data() {
    return {
      query: this.$route.params.query || '',
      products: [],
      page: 1,
      totalPages: 1
    }
  },
  created() {
    this.loadProducts()
  },
  methods: {
    loadProducts() {
      if (this.query) {
        apisProducts.search(this.query, "", "", this.page - 1)
          .then(response => {
            this.products = response.content
            this.totalPages = response.totalPages || 1
          })
          .catch(error => {
            console.error("Error fetching products:", error)
          })
      }
    },
    onPageChange(newPage) {
      this.page = newPage
      this.loadProducts()
    }
  }
}
</script>

<style scoped>
.search-container {
  background-color: #0f172a; /* Fondo general oscuro */
  color: #e2e8f0;
  min-height: 100vh;
  padding-bottom: 40px;
  box-shadow: 0 0 20px rgba(0,0,0,0.4);
}

.header-title {
  background: linear-gradient(135deg, #102b65, #1e3a8a);
  color: #fff;
  font-weight: 600;
  font-size: 1.3rem;
  padding: 16px;
  text-align: center;
  border-bottom: 1px solid rgba(255,255,255,0.1);
  letter-spacing: 0.5px;
}

.highlight {
  color: #38d8f5;
  font-weight: bold;
}


.card-products {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 20px;
  justify-content: center;
  padding: 20px;
  background: radial-gradient(circle at top left, #1e293b, #0f172a);
  border-radius: 16px;
  box-shadow: inset 0 0 25px rgba(0,0,0,0.3);
}

.ComponentProduct {
  height: 400px;
  width: 22%;
  padding: 10px;
  transition: transform 0.2s ease, box-shadow 0.2s ease;
}

.ComponentProduct:hover {
  transform: scale(1.03);
  box-shadow: 0 0 20px rgba(56, 216, 245, 0.3);
}

@media screen and (max-width: 800px) {
  .card-products {
    gap: 10px;
  }
  .ComponentProduct {
    width: 90%;
    height: auto;
  }
}
</style>
